import {
  CASE_GENERAL_FIELDS,
  CASE_REVIEW_CORRECTION_FIELDS,
  defineAnalysisReviewRules,
  type DefineRule,
  type RuleConditions,
} from "./ability-rule-conditions";

export const defineNegotiatorRules = (can: DefineRule, conditions: RuleConditions) => {
  const editableCase = { step: { $in: ["analysis", "negotiation"] } };

  can("read", "Case", conditions.assignedCase);
  can("update", "Case", [...CASE_GENERAL_FIELDS, "contacts", "damages", "debt", "paymentPlan"], {
    ...conditions.ownCase,
    ...editableCase,
  });
  can("update", "Case", [...CASE_GENERAL_FIELDS, "contacts", "damages", "debt", "paymentPlan"], {
    ...conditions.assignedCase,
    ...editableCase,
  });
  can("manageNotes", "Case", conditions.assignedCase);
  can(["delete", "analyze"], "Case", conditions.ownCase);
  can(["delete", "analyze"], "Case", conditions.openCreationReview);
  defineAnalysisReviewRules(can, conditions);
  can("update", "Case", [...CASE_REVIEW_CORRECTION_FIELDS], {
    ...conditions.assignedAnalysisReview,
    ...editableCase,
  });
  can("manageConversations", "Case", conditions.assignedCase);
  can("viewHistory", "Case", conditions.assignedCase);
  can("create", "Task", conditions.assignedCaseTask);
  can("read", "Task", conditions.createdTask);
  can(
    ["read", "update", "execute", "createReminder", "updateReminder", "removeReminder"],
    "Task",
    conditions.assignedTask,
  );
  can("create", "Document");
  can(["read", "readAnalysis"], "Document", { visibleTo: "Negotiator" });
  can("update", "Document", conditions.editableCaseDocument);
  can(["read", "update"], "Profile");
  can("read", "Financial");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};

export const defineLegalRules = (can: DefineRule, conditions: RuleConditions) => {
  can("read", "Case", conditions.assignedCase);
  can(
    "update",
    "Case",
    [
      ...CASE_GENERAL_FIELDS,
      "contacts",
      "damages",
      "debt",
      "paymentPlan",
      "prescriptionPeriodYears",
    ],
    conditions.ownCase,
  );
  can("deleteContacts", "Case");
  can("update", "Case", ["contacts"], conditions.assignedCase);
  can("manageNotes", "Case", conditions.assignedCase);
  can(["delete", "analyze"], "Case", conditions.ownCase);
  can(["delete", "analyze"], "Case", conditions.openCreationReview);
  defineAnalysisReviewRules(can, conditions);
  can(
    "update",
    "Case",
    [...CASE_REVIEW_CORRECTION_FIELDS, "prescriptionPeriodYears"],
    conditions.assignedAnalysisReview,
  );
  can("manageConversations", "Case", conditions.assignedCase);
  can("viewHistory", "Case", conditions.assignedCase);
  can(["create", "createPrimary"], "Task", conditions.assignedCaseTask);
  can(
    ["read", "update", "execute", "createReminder", "updateReminder", "removeReminder"],
    "Task",
    conditions.assignedTask,
  );
  can(["create", "update"], "Document");
  can(["read", "readAnalysis"], "Document", { visibleTo: "Legal" });
  can(["read", "update"], "Profile");
  can("read", "Financial");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};
